import React from 'react';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#faeee2]">
      <section className="relative pt-44 pb-20 md:pt-52 md:pb-28 overflow-hidden bg-brand-deepBrown">
        <div className="absolute inset-0 z-0">
          <img 
            src="img/about-1.avif" 
            alt="Corporate Office" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/75 backdrop-blur-[2px]"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-aos="fade-up">
          <span className="inline-block px-5 py-1.5 rounded-full border border-brand-orange/40 bg-brand-orange/10 text-brand-orange text-xs md:text-sm font-bold tracking-widest uppercase mb-6 backdrop-blur-sm">
            ABOUT CAPILANO
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-white mb-6 leading-tight">
            Who <span className="text-brand-orange">We Are</span>
          </h1>
          <p className="text-base md:text-lg text-[#faeee2]/90 leading-relaxed max-w-2xl mx-auto">
            Ignite your potential and drive your business forward with our expert consultants and cutting-edge strategies.
          </p>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div data-aos="fade-right">
            <span className="text-xs font-bold text-brand-orange uppercase tracking-widest block mb-2">Our Strategic Foundation</span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-deepBrown mb-6">
              Empowering Global Enterprises Through Strategic Excellence
            </h2>
            <p className="text-brand-grayBrown leading-relaxed mb-6">
              Capilano Consulting is a premier management consulting and market research firm focused on delivering actionable insights, strategic expansion models, and operational excellence for global trading enterprises, commodities firms, and industrial conglomerates.
            </p>
            <p className="text-brand-grayBrown leading-relaxed mb-8">
              We bridge complex market dynamics with precision strategies, providing key stakeholders with data-driven research, high-impact marketing consultancy, and sound corporate governance.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 border-t border-[#f2decb] pt-6">
              <div>
                <span className="block text-3xl font-serif font-bold text-brand-orange">100%</span>
                <span className="text-xs text-brand-darkBrown font-bold uppercase tracking-wider">Tailored Frameworks</span>
              </div>
              <div>
                <span className="block text-3xl font-serif font-bold text-brand-orange">4+</span>
                <span className="text-xs text-brand-darkBrown font-bold uppercase tracking-wider">Practice Areas</span>
              </div>
              <div>
                <span className="block text-3xl font-serif font-bold text-brand-orange">Global</span>
                <span className="text-xs text-brand-darkBrown font-bold uppercase tracking-wider">Market Reach</span>
              </div>
            </div>
          </div>

          <div data-aos="fade-left" className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white bg-[#f2decb]">
              <img 
                src="img/about-2.avif" 
                alt="Executive Strategic Consultation"
                className="w-full h-[480px] object-cover" 
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#f2decb]/40 border-y border-[#a17644]/20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-16" data-aos="fade-up">
            <span className="text-xs font-bold text-brand-orange uppercase tracking-widest block mb-2">Our Values</span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-deepBrown mb-4">
              Core Principles & Advisory Ethics
            </h2>
            <p className="text-brand-grayBrown text-sm md:text-base">
              The foundational values guiding our market research methodologies, operational audits, and corporate expansion strategies.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl border border-[#a17644]/20 shadow-md" data-aos="fade-up" data-aos-delay="100">
              <div className="w-12 h-12 rounded-xl bg-[#faeee2] border border-brand-orange/30 flex items-center justify-center text-brand-orange text-xl mb-6 font-serif font-bold">01</div>
              <h3 className="text-xl font-serif font-bold text-brand-deepBrown mb-3">Empirical Rigor</h3>
              <p className="text-brand-grayBrown text-sm leading-relaxed">
                Our market intelligence is rooted in raw empirical data, rigorous field research, and deep competitive benchmarking rather than assumptions.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl border border-[#a17644]/20 shadow-md" data-aos="fade-up" data-aos-delay="200">
              <div className="w-12 h-12 rounded-xl bg-[#faeee2] border border-brand-orange/30 flex items-center justify-center text-brand-orange text-xl mb-6 font-serif font-bold">02</div>
              <h3 className="text-xl font-serif font-bold text-brand-deepBrown mb-3">Actionable Clarity</h3>
              <p className="text-brand-grayBrown text-sm leading-relaxed">
                We eliminate abstract complexity, offering clear step-by-step implementation roadmaps designed to produce quantifiable returns.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl border border-[#a17644]/20 shadow-md" data-aos="fade-up" data-aos-delay="300">
              <div className="w-12 h-12 rounded-xl bg-[#faeee2] border border-brand-orange/30 flex items-center justify-center text-brand-orange text-xl mb-6 font-serif font-bold">03</div>
              <h3 className="text-xl font-serif font-bold text-brand-deepBrown mb-3">Sustainable Value</h3>
              <p className="text-brand-grayBrown text-sm leading-relaxed">
                We craft resilient structures for trading, industrial manufacturing, and commodity distribution that thrive over the long term.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 text-center">
        <div className="max-w-3xl mx-auto" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-deepBrown mb-6">
            Partner With Our Strategic Advisors
          </h2>
          <p className="text-brand-grayBrown text-base mb-8">
            Discover how our management consultancy and market research expertise can unlock transformative opportunities for your company.
          </p>
          <Link
            to="/contact"
            className="inline-block px-8 py-4 bg-brand-orange text-white font-semibold rounded-full hover:bg-brand-darkBrown transition-colors duration-300 shadow-md text-sm uppercase tracking-wider"
          >
            Schedule Strategic Discussion
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;